// extracted by mini-css-extract-plugin
export var componentcta = "ComponentCTA-module--componentcta--0d87a";
export var left = "ComponentCTA-module--left--15b80";